export const lightspeed = {
  seo: {
    title: 'Lightspeed Integration | Bistroo',
    description: 'Verbinde dein Lightspeed-Kassensystem mit Bistroo. Online-Bestellungen gehen automatisch als Kassentickets ein, kein manuelles Abtippen, keine Fehler.',
  },
  hero: {
    category: 'Kassensystem',
    description: 'Kombiniere Bistroos moderne Bestelllösungen mit dem führenden Kassensystem von Lightspeed. Eine Integration, unendliches Komfort für deinen Restaurantbetrieb.',
    badge: 'Offizieller Integrationspartner',
    check_1: 'Unverbindlich und monatlich kündbar',
    check_2: 'Einrichtung in wenigen Minuten',
  },
  about: {
    title: 'Was macht Lightspeed?',
    p1: 'Lightspeed Restaurant ist ein Cloud-Kassensystem, das speziell für die Gastronomie entwickelt wurde. Es bietet Echtzeit-Einblicke in deinen Umsatz, Lagerverwaltung und Dienstpläne – alles aus einem Dashboard, auf jedem Gerät. Tausende von Gastronomen vertrauen auf Lightspeed.',
    p2: 'Mit der Bistroo-Anbindung gehen Online-Bestellungen aus deinem Webshop direkt als Kassatransaktionen in Lightspeed ein. Dein Team muss nichts abtippen; alles läuft automatisch. Weniger Fehler, weniger Stress und ein reibungsloserer Betrieb in den geschäftigsten Stoßzeiten.',
    benefits_title: 'Was bringt die Anbindung?',
    benefits: [
      'Online-Bestellungen landen automatisch in deinem Lightspeed-Kassensystem',
      'Menüanpassungen in Bistroo werden synchronisiert',
      'Liefer- und Abholzeiten werden als Anweisungen weitergegeben',
      'Echtzeit-Umsatzberichte über alle Kanäle kombiniert',
      'Keine doppelte Verwaltung: ein System für Kasse und Webshop',
    ],
  },
  wordcloud_title: 'Lightspeed auf einen Blick',
  wordcloud: ['Cloud POS', 'Gastronomiekasse', 'Tischverwaltung', 'Lagerverwaltung', 'Kassentickets', 'Echtzeit-Berichte', 'Cloud-basiert', 'Bestellströme', 'Automatisierung', 'Speisekarte', 'API-Anbindung', 'Küchendrucken', 'Umsatzanalyse', 'Multi-Standort', 'Gastgewerbesoftware'],
  usp: {
    heading: 'Alles was Sie brauchen, perfekt integriert',
    subtitle: 'Leistungsstarke Funktionen, die nahtlos zusammenarbeiten, um Ihren Restaurantbetrieb zu optimieren',
    items: [
      { icon: 'bi-lightning-charge-fill', title: 'Echtzeit-Synchronisation', text: 'Bestellungen, Menü, Inventar und Verkaufsdaten sofort zwischen Bistroo und Lightspeed POS synchronisiert.' },
      { icon: 'bi-bar-chart-fill', title: 'Manuelle Zeitbestätigung', text: 'Einzigartig für diese Integration ist die Möglichkeit, Abhol- oder Lieferbestellungen manuell eine Zeit zuzuweisen.' },
      { icon: 'bi-clock-fill', title: 'Zeitersparnis & Spitzenlast-Management', text: 'Beseitige manuelle Dateneingabe und werde während Stoßzeiten nie mehr überfordert mit Bistroos intelligentem Zeitschlitz-Algorithmus.' },
      { icon: 'bi-people-fill', title: 'Vorbestellungen, wie sie sein sollten', text: 'Bestellungen vor Restaurantöffnung, aber immer gedruckt bei Öffnung am Liefertag.' },
      { icon: 'bi-printer-fill', title: 'Nahtlose Integration mit der Küche', text: 'Drucken oder zeigen Sie Webshop-Bestellungen direkt über Lightspeed in Ihrer Küche, wie gewohnt.' },
      { icon: 'bi-check-circle-fill', title: 'Kein administrativer Aufwand', text: 'Die Verwaltung Ihrer Online-Webshop-Bestellungen direkt in Ihrem Tagesabschluss über die Kasse.' },
    ],
  },
  partnership: {
    title: 'Integration für Wachstum gebaut',
    subtitle: 'Unsere Partnerschaft bringt das Beste aus beiden Welten zusammen: Bistroos innovative Bestelltechnologie und das führende Kassensystem von Lightspeed.',
    visual_bistroo: 'Bistroo Webshop',
    visual_bistroo_sub: 'Bestellungen & Verwaltung',
    visual_lightspeed: 'Lightspeed POS',
    visual_lightspeed_sub: 'Kassensystem',
    visual_status: 'Verbunden & Synchronisiert',
  },
  setup: {
    heading: 'So verknüpfst du Lightspeed mit Bistroo',
    steps: [
      'Melde dich bei deinem Bistroo Merchant Portal an und gehe zu Einstellungen.',
      'Öffne den Reiter Integrationen und klicke auf Lightspeed.',
      'Melde dich mit deinem Lightspeed-Konto an und autorisiere die Anbindung über OAuth.',
      'Verknüpfe deine Menükategorien mit den richtigen Lightspeed-Abteilungen.',
      'Verarbeite eine Testbestellung – das Ticket erscheint direkt in deiner Kasse.',
    ],
  },
  faq: {
    items: [
      { q: 'Welche Version von Lightspeed benötige ich?', a: 'Die Bistroo-Anbindung funktioniert mit Lightspeed Restaurant (K-Series). Stelle sicher, dass dein Abonnement API-Zugang beinhaltet; dies ist bei den meisten kostenpflichtigen Lightspeed-Plänen der Fall.' },
      { q: 'Werden Menüanpassungen automatisch synchronisiert?', a: 'Ja. Wenn du ein Produkt in Bistroo hinzufügst oder anpasst, wird das automatisch an Lightspeed weitergegeben. Umgekehrt kannst du Änderungen auch aus Lightspeed in Bistroo importieren.' },
      { q: 'Kann ich mehrere Verkaufsstellen verknüpfen?', a: 'Sicher. Wenn du mehrere Filialen hast, kannst du pro Standort einen separaten Bistroo-Webshop mit dem entsprechenden Lightspeed-Verkaufspunkt verknüpfen.' },
      { q: 'Was passiert, wenn die Internetverbindung ausfällt?', a: 'Bistroo speichert Bestellungen in der Cloud. Sobald die Verbindung wiederhergestellt ist, werden ausstehende Bestellungen automatisch an Lightspeed weitergeleitet.' },
      { q: 'Ist die Lightspeed-Anbindung in meinem Bistroo-Abonnement enthalten?', a: 'Ja, die Anbindung ist Teil deines Standard-Bistroo-Abonnements. Es gibt keine zusätzlichen Installationskosten.' },
    ],
  },
  cta: {
    title: 'Bereit, es kostenlos zu testen?',
    subtitle: 'Starte heute und erlebe, wie Bistroo und Lightspeed für dein Restaurant zusammenarbeiten. Keine Einrichtungskosten, monatlich kündbar.',
    button_primary: 'Kostenlos starten',
    button_secondary: 'Demo planen',
    footer_text: 'Einrichtung in weniger als 10 Minuten · Jederzeit kündbar',
  },
}
